// 快訊日曆內容 (日曆或新聞)
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

const FlashCalendarContent = ({ selectedContent }) => {
    const { t } = useTranslation();
    const now = dayjs();
    const dateKey = dayjs(selectedContent?.news?.dateKey);

    // 依時間顯示新聞文案
    const handleTitle = !dateKey.isSame(now, 'year')
        ? 'LAST_YEAR'
        : dateKey.isBefore(now)
        ? 'BEFORE'
        : 'TODAY';

    return (
        <div
            className="my-[4px] relative rounded-[4px] bg-[#FDFDFD] w-full dark:bg-[#262626] px-[30px] py-[8px] max-w-full
        ulg:px-[15px] usm:w-screen usm:max-w-[unset] usm:left-[50%] usm:translate-x-[-50%] usm:rounded-[0]"
        >
            {/* 新聞 */}
            {selectedContent?.news ? (
                <a
                    href={`/news/${selectedContent?.news?.slug}`}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="py-[9px] flex items-center justify-start gap-x-[15px] text-btn1 text-black group
                    umd:border-b-1 umd:border-dashed umd:border-black2 last:!border-0"
                >
                    <span className="w-[6px] h-[6px] rounded-[50%] bg-pale trans group-hover:opacity-0 flex-shrink-0" />
                    <div className="flex items-center gap-x-[15px] trans group-hover:translate-x-[-15px]">
                        <p className="flex-shrink-0">{t(handleTitle)}</p>
                        {/* 分隔線 */}
                        <span className="w-[1px] h-[10px] border-l-1 border-black2" />
                        {/* 新聞標題 */}
                        <p className="line-clamp-1">{selectedContent?.news?.title}</p>
                    </div>
                </a>
            ) : (
                // 事件
                selectedContent?.calendar?.map((event) => (
                    <a
                        key={event?.title + event?.id}
                        href={event?.link || null}
                        target="_blank"
                        rel="noreferrer noopener"
                        className={`py-[9px] flex items-center justify-start gap-x-[15px] text-btn1 text-black ${
                            event?.link ? 'group' : 'cursor-default'
                        } umd:border-b-1 umd:border-dashed umd:border-black2 last:!border-0`}
                    >
                        <span className="w-[6px] h-[6px] rounded-[50%] bg-pale trans group-hover:opacity-0 flex-shrink-0" />
                        <div className="flex items-center trans group-hover:translate-x-[-15px] flex-grow umd:justify-between umd:gap-x-[15px]">
                            <div className="flex-grow w-[35%] max-w-[35%] flex-shrink-0 blg:w-[30%] blg:max-w-[30%] bmd:w-[30%] bmd:max-w-[30%] usm:w-[unset] uxs:!w-full uxs:!max-w-[unset]">
                                <p className="line-clamp-1">
                                    {event?.type === 'unlocked' && t('UNLOCK')}
                                    {event?.title}
                                </p>
                                {/* 時間 */}
                                <span className="block text-bt2n text-black5 mt-[9px]">
                                    {dayjs(event?.releaseTime).format('HH:mm')}
                                </span>
                            </div>

                            {event?.type !== 'customized' && (
                                <>
                                    {/* 分隔線  */}
                                    <span className="w-[1px] h-[10px] border-l-1 border-black2 mx-[20px] umd:hidden" />

                                    {/* 環比  */}
                                    {event?.type === 'marco' && (
                                        <span className="w-[39px] text-center mr-[20px] flex-shrink-0 umd:hidden">
                                            {event?.period?.toUpperCase() || ''}
                                        </span>
                                    )}

                                    <div
                                        className="flex items-center flex-shrink gap-x-[30px] [&>p]:text-bd3n [&>p]:flex [&>p]:items-center [&>p]:gap-x-[7px] [&_span]:text-btn3b [&>p]:flex-wrap
                                    umd:[&>p]:flex-col umd:[&>p]:items-center usm:flex-shrink usm:gap-x-[10px] usm:[&>p]:flex-shrink usx:!gap-x-[5px] uxs:!hidden"
                                    >
                                        {/* 事件 */}
                                        {event?.type === 'marco' ? (
                                            <>
                                                {/* 環比  */}
                                                <p className="!hidden w-[39px] text-center umd:!block usx:!hidden">
                                                    {event?.period?.toUpperCase() || 'MOM'}
                                                </p>

                                                {/* 公布值 */}
                                                <p>
                                                    {t('ANNOUNCED_VALUE')}
                                                    <span>{event?.announcedValue || 'TBA'}</span>
                                                </p>
                                                {/* 預測值 */}
                                                <p>
                                                    {t('FORECAST_VALUE')}
                                                    <span>{event?.forecastValue || 'TBC'}</span>
                                                </p>
                                                {/* 前值 */}
                                                <p>
                                                    {t('PREVIOUS_VALUE')}
                                                    <span>{event?.previousValue || 'TBC'}</span>
                                                </p>
                                            </>
                                        ) : (
                                            // 代幣解鎖
                                            <>
                                                {/* 解鎖量 */}
                                                <p>
                                                    {t('UNLOCKED_AMOUNT')}
                                                    <span>{event?.unlockedAmount}</span>
                                                </p>
                                                {/* 流通供應量 */}
                                                <p>
                                                    {t('SUPPLY')}
                                                    <span>{event?.supply}</span>
                                                </p>
                                                {/* 價值 */}
                                                <p>
                                                    {t('VALUE')}
                                                    <span>{event?.unlockedValue}</span>
                                                </p>
                                            </>
                                        )}
                                    </div>
                                </>
                            )}
                        </div>
                    </a>
                ))
            )}
        </div>
    );
};

export default FlashCalendarContent;
